import { Copy, Download, ImagePlus } from "lucide-react";
import { Button } from "../ui/button.tsx";
import { Dialog, DialogContent, DialogTrigger } from "../ui/dialog.tsx";
import { useEffect, useState } from "react";
import { Catalog } from "./api/single-post-api";
import { UseFormReturn } from "react-hook-form";
import { PostBodyFormType, SocialPostType } from "./types";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import GallerySelector from "../gallery-new";
import ImageCarousel from "./ImageCarousel";

type Props = {
  post_id: number,
  story_id: number,
  event_id: number,
  imgUrl: string | null,
  onSaveImage: (url: string) => void,
  isSuccess: boolean,
  onSavePost: () => void,
  postForm: UseFormReturn<PostBodyFormType>,
  catalog: Catalog[],
  content: SocialPostType["content"][number],
}
const ImageSection = ({ content, imgUrl, onSaveImage, event_id, story_id }: Props) => {

  const theme = useAtomValue(themeAtom)

  const [image, setImage] = useState<string | null>(imgUrl)

  useEffect(() => {
    setImage(imgUrl)
  }, [imgUrl])

  return (
    <div className="w-full md:w-1/2 p-4 flex flex-col sm:flex-row md:flex-col gap-5">
      <div className="w-full h-fit flex flex-col gap-2">
        {content.image_ids !== null && <ImageCarousel images={content.image_ids} />}
        <Dialog>
          <DialogTrigger>
            {image !== null && <img
              src={image}
              loading="lazy"
              className="w-2/3 sm:w-full h-fit rounded-lg cursor-pointer"
              alt="Preview"
              width="500px"
              height="500px"
            />}
          </DialogTrigger>
          <DialogContent className="max-w-2xl bg-black text-purple-500 font-semibold border-none outline-black p-0">
            <div className="absolute bottom-2 right-2 flex items-center gap-2">
              <Button size="icon"
                title="Download Image"
                className=""
                onClick={() => {
                  if (image !== null) {
                    const link = document.createElement('a');
                    link.href = image;
                    link.download = image.split('/').pop() || 'image';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }
                }}>
                <Download />
              </Button>
              <Button size="icon"
                onClick={() => {
                  navigator.clipboard.writeText(content.image_video_recommendation)
                }}
              >
                <Copy />
              </Button>
            </div>
            <img src={imgUrl !== null ? imgUrl : ""} className="w-full h-auto rounded-lg" alt="Full View" />
          </DialogContent>
        </Dialog>
        <div className="flex items-center gap-3 w-full">
          <GallerySelector
            story_id={story_id}
            event_id={event_id}
            isCarousel
            selectedImages={content.image_ids !== null ? content.image_ids : []}
            onSave={onSaveImage}
            content={content}
            trigger={
              <Button style={{ backgroundColor: theme.primary }} className="flex bg-theme-primary items-center gap-2 justify-center">
                <ImagePlus />
                <span> {imgUrl ? "Change Image" : "Select Image"}</span>
              </Button>
            } />
        </div>
      </div>
    </div>
  )
}

export default ImageSection;
